import Immutable from 'seamless-immutable';
import { createActions, createReducer } from 'reduxsauce';

/* Action types and creators */

export const { Types, Creators } = createActions({
  showModalServices: [],
});

const INITIAL_STATE = Immutable({
  show: false,
});

const showModalServices = (state = INITIAL_STATE, action) =>
  ({ ...state, show: action.payload });

export default createReducer(INITIAL_STATE, {
  [Types.SHOW_MODAL_SERVICES]: showModalServices,
});
